module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product22-96ca68cd9c1f5ed0b47e997e34aa8aa6.jpg";